import React from 'react';
import {
  Link,
  useLoaderData,
} from '@tanstack/react-router';

import DashboardMemoryCard from './MemoryCard';
import Pagination from '../Pagination';
import PaginationHeader from '../PaginationHeader';

import type { Memory } from '../../types/memory';

interface DashboardSprksProps {
  style?: 'default' | 'short';
};

const DashboardSprks: React.FC<DashboardSprksProps> = ({ style = 'default' }) => {
  const { sprks: sprksData } = useLoaderData({ strict: false });
  const sprks = sprksData?.data || [];
  const totalSprks = sprksData?.meta.total;
  const mode = sprksData?.meta.mode || 'created';

  return (
    <>
      {style !== 'short' && (
        <div className="dashboard-header page-header">
          {mode === 'received' ? (
            <>
              <h2 className="page-title">Received <em>SPRKs</em></h2>
              <p>All SPRKs that have been shared with you.</p>
            </>
          ) : (
            <>
              <h2 className="page-title">My <em>SPRKs</em></h2>
              <p>The moments, thoughts, and feelings you’ve captured and shared as SPRKs.</p>
            </>
          )}
        </div>
      )}
      <div className="dashboard-memories wa-stack wa-gap-0 inner">
        <div className="wa-grid">
          {(sprks.length > 0 || style === 'short') && (
            <div className="page-eyebrow">
              SPRKs
            </div>
          )}
          {totalSprks > 0 && (
            <div className="total-items">
              {style === 'short' ? (
                <Link to="/dashboard/sprks">
                  View all SPRKs ({totalSprks})
                </Link>
              ) : (
                <PaginationHeader text="SPRK" total={totalSprks} />
              )}
            </div>
          )}
        </div>
        {sprks.length === 0 && (
          <div className="empty-state wa-stack wa-gap-md">
            <div className="center">
              {mode === 'received' ? (
                <>
                  You haven't received any SPRKs yet.
                </>
              ) : (
                <>
                  You don't have any SPRKs yet. Create one!
                </>
              )}
            </div>
            <div className="center">
              {mode !== 'received' && (
                <Link to="/memories/create?variant=sprk">
                  <wa-button className="cta-button">
                    Create SPRK
                  </wa-button>
                </Link>
              )}
            </div>
          </div>
        )}
        <div className="dashboard-memories-list wa-cluster">
          {sprks.map((memory: Memory) => (
            <DashboardMemoryCard key={memory.id} memory={memory} />
          ))}
        </div>
        {style !== 'short' && (
          <Pagination total={sprksData?.meta.total} />
        )}
      </div>
    </>
  );
}

export default DashboardSprks;
